exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".vue-editor-control.disabled[data-v-e82b9544]{background-color:#ddd;opacity:.8}.vue-editor-control.disabled .ql-toolbar[data-v-e82b9544],.vue-editor-control.readonly .ql-toolbar[data-v-e82b9544]{display:none}.disabled-mode[data-v-e82b9544],.readonly-mode[data-v-e82b9544]{padding:20px;color:#999;font-size:.8rem}", ""]);

